import React from 'react'
/**
 * don't change import order
 * ['.dotenv', './js/nclk.js']
 */
import './dotenv'
import './js/nclk.js'

const NClick = (_params: any) => {
  return _params.nclk_v2
}

const handleClickHTML = (nclickElement: HTMLElement, evt: MouseEvent) => {
  const nclickData = nclickElement.getAttribute('data-nclk')
  const contentId = nclickElement.getAttribute('data-ncId')
  const rank = nclickElement.getAttribute('data-nrank')
  const targetattr = nclickElement.getAttribute('target')
  const toUrl = nclickElement.getAttribute('href')

  if (toUrl && toUrl.indexOf('void(0)') < 0 && toUrl.indexOf('javascript:;') < 0) {
    evt.preventDefault()
    evt.stopPropagation()
  }

  if (nclickData) {
    NClick(global)(evt || this, nclickData, contentId !== '' && contentId !== undefined ? contentId : '', rank !== '' && rank !== undefined ? rank : '')
  }

  if (toUrl && toUrl !== '' && toUrl !== '#' && toUrl.indexOf('void(0)') < 0 && toUrl.indexOf('javascript:;') < 0) {
    if (targetattr === '_blank') {
      window.open(toUrl)
    } else {
      window.location.href = toUrl
    }
  }
}

const clickEventListener = (e: MouseEvent) => {
  const elements = e.composedPath() || []
  const nclickElement = elements.find((element) => {
    return element instanceof HTMLElement && element.dataset && element.dataset.hasOwnProperty('nclk')
  })

  if (nclickElement && nclickElement instanceof HTMLElement) {
    handleClickHTML(nclickElement, e)
  }
}

const addNclickEventListener = () => {
  // user agent
  const ua = navigator.userAgent
  const doc = document
  const html = doc.getElementsByTagName('HTML')[0]

  html.setAttribute('data-user-agent', ua)
  // Lcs
  document.body.addEventListener('click', clickEventListener)
}

const removeNclickEventListener = () => {
  const doc = document
  const html = doc.getElementsByTagName('HTML')[0]

  html.removeAttribute('data-user-agent')
  document.body.removeEventListener('click', clickEventListener)
}

const handleNclick = (nclickName: string, evt?: React.SyntheticEvent) => {
  if (nclickName) {
    NClick(global)?.(evt || this, nclickName, null, null)
  }
}

const handleNclickMix = (nclickName?: string, handleClick?: (evt: any, ...args: any) => void, ...args: any) => {
  return (evt: React.SyntheticEvent) => {
    nclickName && handleNclick(nclickName, evt)
    handleClick && handleClick(evt, ...args)
  }
}

export { addNclickEventListener, removeNclickEventListener, handleNclick, handleNclickMix }
